var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPencilcopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_8610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3161 0.260258C12.4828 0.0936147 12.7089 0 12.9446 0C13.1803 0 13.4064 0.0936147 13.573 0.260258L16.2397 2.92696C16.4064 3.09365 16.5 3.3197 16.5 3.55541C16.5 3.79111 16.4064 4.01717 16.2397 4.18386L8.23965 12.184C8.07299 12.3507 7.84693 12.4444 7.6112 12.4444H4.9445C4.70875 12.4444 4.48265 12.3508 4.31595 12.1841C4.14925 12.0173 4.0556 11.7913 4.0556 11.5555V8.8888C4.05565 8.65307 4.14933 8.42702 4.31605 8.26035L12.3161 0.260258ZM5.8334 9.25681V10.6666H7.24319L14.3544 3.55541L12.9446 2.14561L5.8334 9.25681ZM0.5 3.55541C0.5 3.08391 0.687303 2.63172 1.02071 2.29831C1.35411 1.96491 1.8063 1.77761 2.2778 1.77761H6.7223C6.95805 1.77761 7.18414 1.87126 7.35084 2.03796C7.51754 2.20466 7.6112 2.43076 7.6112 2.66651C7.6112 2.90226 7.51754 3.12835 7.35084 3.29506C7.18414 3.46176 6.95805 3.55541 6.7223 3.55541H2.2778V14.2222H12.9446V9.7777C12.9446 9.54195 13.0382 9.31586 13.2049 9.14916C13.3716 8.98246 13.5977 8.8888 13.8335 8.8888C14.0692 8.8888 14.2953 8.98246 14.462 9.14916C14.6287 9.31586 14.7224 9.54195 14.7224 9.7777V14.2222C14.7224 14.6937 14.5351 15.1459 14.2017 15.4793C13.8683 15.8127 13.4161 16 12.9446 16H2.2778C1.8063 16 1.35411 15.8127 1.02071 15.4793C0.687303 15.1459 0.5 14.6937 0.5 14.2222V3.55541Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_8610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencilcopy);
export default __webpack_public_path__ + "static/media/edit-pencil copy.12231a5a6f5da8aa32065a171277fd8c.svg";
export { ForwardRef as ReactComponent };